import type { MapBoxFilterParams } from "@/react/components/shared/Filter/FilterTypes/MapboxInputFilter";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { useMemberFilterUrl } from "@/react/components/shared/MemberFilters/useMemberFilterUrlV2";

export const useNearMeFilter = (): {
  nearMeFilter: MapBoxFilterParams | undefined;
  isNearMeActive: boolean;
} => {
  const { filterParams } = useMemberFilterUrl();

  const nearMeFilter = filterParams.find(
    (filter: BaseFilter) => filter.key === "near_me",
  );

  if (!nearMeFilter) {
    return { nearMeFilter: undefined, isNearMeActive: false };
  }

  return {
    nearMeFilter: nearMeFilter as MapBoxFilterParams,
    isNearMeActive: true,
  };
};
